import { noop } from 'lodash';
import { ReactElement } from 'react';

import {
   AuthorizationResult,
   CurrentHealthcareProviderPaymentsAuthorizationQuery,
} from '@dreryk/egabinet-online-payments-integration-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { onlinePaymentsSharedTranslationKeys } from '../../translations';

type OnlinePaymentsIntegrationStatusRenderProps = {
   onlinePaymentsAuthorizationConfiguration: AuthorizationResult;
};

type OnlinePaymentsIntegrationStatusProps = {
   readonly children: (renderProps: OnlinePaymentsIntegrationStatusRenderProps) => ReactElement;
};

export const OnlinePaymentsIntegrationStatusLoader = (props: OnlinePaymentsIntegrationStatusProps): ReactElement => {
   const {
      data: onlinePaymentsAuthorizationConfiguration,
      loading: onlinePaymentsAuthorizationConfigurationLoading,
      error: onlinePaymentsAuthorizationConfigurationError,
   } = useCqrsGet<AuthorizationResult>(() => new CurrentHealthcareProviderPaymentsAuthorizationQuery(), {
      onUnexpectedError: noop,
   });

   if (onlinePaymentsAuthorizationConfigurationLoading) {
      return <LoaderSpinner />;
   }

   if (onlinePaymentsAuthorizationConfigurationError) {
      return (
         <Message
            testId={'failedToFetchAuthorizationData'}
            label={onlinePaymentsSharedTranslationKeys.fetchError}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      onlinePaymentsAuthorizationConfiguration: onlinePaymentsAuthorizationConfiguration,
   });
};
